<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="760px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="姓名："
        prop="userId">
        <el-input
          v-if="!info.courseScoreId"
          v-model="info.userName"
          readonly>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="selectPerson"></el-button>
        </el-input>
        <span v-else>{{ info.userName }}</span>
      </el-form-item>
      <el-form-item label="手机号：">{{ info.mobilePhone }}</el-form-item>
      <el-form-item label="身份证号：">{{ info.idCertNo }}</el-form-item>
      <el-form-item
        label="考试结果："
        prop="evaluate">
        <el-radio-group v-model="info.evaluate">
          <el-radio-button :label="1">通过</el-radio-button>
          <el-radio-button :label="0">未通过</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
    <user-select-modal
      ref="select"
      :callback="userCallback" />
  </el-dialog>
</template>
<script>
import UserSelectModal from '../luxury-users/user-select-modal.vue'

export default {
  name: 'EditCourseScoreModal',
  components: { UserSelectModal },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        courseExamId: null,
        courseScoreId: null,
        userId: '',
        userName: '',
        mobilePhone: '',
        idCertNo: '',
        evaluate: 1
      },
      rules: {
        userId: [
          { required: true, message: '请选择考试人员', trigger: 'blur' }
        ],
        evaluate: [
          { required: true, message: '请选择考试结果', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title() {
      const courseScoreId = this.info.courseScoreId
      return (courseScoreId ? '编辑' : '新增') + '考试成绩'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    selectPerson() {
      this.$refs.select.fetch()
    },
    userCallback(row) {
      console.log(row)
      this.info.userId = row.userId
      this.info.userName = row.userName
      this.info.mobilePhone = row.mobilePhone
      this.info.idCertNo = row.idCertNo
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        courseExamId: null,
        courseScoreId: null,
        userId: '',
        userName: '',
        mobilePhone: '',
        idCertNo: '',
        evaluate: 1
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.courseScoreId
            ? 'updatecoursescore'
            : 'addcoursescore'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
